// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var User = function User(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.013.747A7.253 7.253 0 1015.266 8 7.253 7.253 0 008.013.747zm0 2.385a2.776 2.776 0 012.622 2.908 2.776 2.776 0 01-2.622 2.908A2.776 2.776 0 015.391 6.04a2.776 2.776 0 012.622-2.909zm4.253 9.2a6.049 6.049 0 01-8.506 0v-.354a2.686 2.686 0 011.748-2.456.807.807 0 01.52 0 7.744 7.744 0 001.984.223A7.743 7.743 0 0010 9.518a.807.807 0 01.52 0 2.686 2.686 0 011.749 2.457z"
    }))
  );
};

export default User;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/User.js
// module id = 1060
// module chunks = 0